import { View, Text, Platform, type TextStyle } from "react-native";
import { useTranslations } from "@src/packages/i18n";
import { EMBER } from "../../../onboarding/theme";
import StatusBadge from "../StatusBadge";

export default function DonorRegistryHeader() {
  const t = useTranslations();
  return (
    <View style={{ gap: 8, marginBottom: 28 }}>
      <View style={{ flexDirection: "row", alignItems: "center", gap: 10 }}>
        <Text
          className="font-dm-sans"
          style={
            {
              fontSize: 38,
              fontWeight: "700",
              color: "#3B1A08",
              lineHeight: 42,
              letterSpacing: -0.5,
              ...(Platform.OS === "web" && {
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.7' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='200' height='200' filter='url(%23n)' opacity='0.06'/%3E%3C/svg%3E"), linear-gradient(135deg, #3B1A08 0%, #7A3E15 35%, #3B1A08 60%, #6B3410 85%, #3B1A08 100%)`,
                backgroundSize: "200px 200px, 100% 100%",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }),
            } as TextStyle
          }
        >
          {t("access.donor_registry.title")}
        </Text>
        <StatusBadge type="beta" />
      </View>
      <View style={{ flexDirection: "row", alignItems: "center", gap: 8 }}>
        <Text
          className="font-dm-sans"
          style={{
            fontSize: 15,
            color: EMBER.colors.textLight,
            flex: 1,
          }}
        >
          {t("access.donor_registry.subtitle")}
        </Text>
      </View>
    </View>
  );
}
